import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const getToken = () => {
	return Cookies.get("token");
};

export const decodeToken = () => {
	try {
		const token = getToken();
		if (!token) return null;
		return jwtDecode(token);
	} catch (error) {
		return null;
	}
};

export function setTokenCookie(token) {
	const opts = {
		path: "/",
		secure: window.location.protocol === "https:",
		sameSite: "Lax",
	};
	if (window.location.hostname.endsWith("chiuchau.com")) {
		opts.domain = ".chiuchau.com";
	}
	Cookies.set("token", token, opts);
}

export function removeTokenCookie() {
	const opts = { path: "/" };
	if (window.location.hostname.endsWith("chiuchau.com")) {
		opts.domain = ".chiuchau.com";
	}
	Cookies.remove("token", opts);
}
